
<accordion [isAnimated]="true">
    <accordion-group [isOpen]="true">
      <span accordion-heading>
        <i class='fa fa-pencil'></i> Observaciones
      </span>
      <form class="form-horizontal" [formGroup]="observationForm">
          <textarea class="form-control"
          formControlName="observationText"
          rows="20"     
          [ngClass]="observationForm.controls.observationText.errors ? 'is-invalid' : 'is-valid'"
          [readonly]="readonly">
          </textarea>
      </form>
    </accordion-group>
    
</accordion>